export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по работе с возражениями клиентов',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер с более чем 18-летним опытом в продажах и переговорах',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по работе с возражениями для отдела продаж. Практическое обучение с диагностикой, реальными кейсами, сопровождением внедрения.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение работе с возражениями',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Что такое работа с возражениями?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Работа с возражениями — это навык профессионального общения с клиентом, при котором менеджер не спорит и не давит, а помогает клиенту получить недостающую информацию, убедиться в ценности предложения и принять взвешенное решение. Это ключевой компонент успешных продаж и переговоров.',
        },
      },
      {
        '@type': 'Question',
        name: 'Почему сотрудники начинают давать скидку при первом возражении?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Сотрудники дают скидку, потому что не умеют продавать ценность и не знают, как отвечать на возражения уверенно. Отсутствие тренировки в реальных ситуациях приводит к страху потерять клиента, и менеджер идёт по пути наименьшего сопротивления — снижает цену вместо того, чтобы укрепить позицию.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить опытных менеджеров работе с возражениями?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, опытные менеджеры часто выигрывают от обучения больше новичков, потому что у них уже есть база практических ситуаций для разбора. Мы работаем с реальными кейсами каждого участника, выявляем скрытые привычки и заменяем неэффективные паттерны на рабочие стратегии.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько длится тренинг по работе с возражениями?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Интенсивный формат — 1–2 дня, модульное обучение — от 2 недель до 2 месяцев, комплексная программа с сопровождением — до 3–6 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли использовать реальные звонки и переписки на тренинге?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, и это обязательная часть программы. Мы прослушиваем реальные записи звонков, анализируем переписки, разбираем конкретные ситуации с реальными клиентами компании. Это повышает вовлечённость в десятки раз и позволяет сразу применить навыки в знакомых сценариях.',
        },
      },
      {
        '@type': 'Question',
        name: 'Проводится ли обучение онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, тренинг по работе с возражениями доступен в онлайн-формате с использованием интерактивных инструментов, ролевых переговоров через видеосвязь, разбора реальных кейсов и записи сессий. Онлайн-формат не уступает очному по эффективности при правильной организации.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли совместить тренинг с обучением переговорам или продажам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, работа с возражениями — это неотъемлемая часть переговоров и продаж. Мы часто интегрируем модуль работы с возражениями в более широкие программы по продажам или переговорам. Такой подход позволяет обучить сотрудников комплексному циклу коммуникации с клиентом.',
        },
      },
      {
        '@type': 'Question',
        name: 'Какие результаты можно ожидать после обучения?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Типичные результаты: рост конверсии на 18–55%, снижение процента скидок, увеличение среднего чека, рост продлений и повторных продаж, уверенность сотрудников в общении с трудными клиентами. Конкретные показатели зависят от исходного уровня команды и активности руководителя во внедрении.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по работе с возражениями',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami', name: 'Тренинг по работе с возражениями' },
      },
    ],
  };

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    jobTitle: 'Бизнес-тренер, эксперт по продажам и переговорам',
    url: 'https://sivko.by/',
    description: 'Бизнес-тренер с 18+ лет опыта в продажах и переговорах. Провёл более 450 корпоративных тренингов для 4500+ участников из Беларуси, России, Казахстана и Израиля.',
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(personSchema) }} />
    </>
  );
}